import React from 'react';
import { Flag, Menu, Embed, Button } from 'semantic-ui-react';
import { withStyles } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl'
import messages from 'shared/messages/messages';
import QrCode from 'shared/components/QrCode';
import config from 'shared/config/config';

import 'semantic-ui-css/semantic.min.css';

import {
    showDeleteMyAcc,
    showTerms,
    showContactUs,
    backToProfile
} from 'shared/actions/profilePageActions';

import {
  selectLocale
} from 'shared/actions/messagesActions';

import {
    getAccessCode
} from 'shared/actions/userActions';

import {
    SHOW_CONTACT_US,
    SHOW_DELETE_MY_ACCOUNT,
    SHOW_TERMS_OF_USE
} from 'shared/actions/types'

import UserService from 'shared/services/UserService';

import { LOCALES } from 'shared/utils/Constants'

import html2canvas from 'html2canvas';

const isMobile = window.innerWidth < 960;

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

var profileComponent;

const styles = theme => ({
  flagOptions: {
    justifyContent: "center"
  },
})

class ProfilePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            qrDialogOpen: false
        }
    }

    onClickDeleteAcc = event => {
        event.preventDefault();
        this.props.showDeleteMyAcc("https://reports.capturelife.com/forms/cl/personaldata.php");
    }

    onClickContactUs = event => {
        event.preventDefault();
        this.props.showContactUs("https://reports.capturelife.com/forms/cl/contactus.php");
    }

    onClickTerms = event => {
        event.preventDefault();
        this.props.showTerms();
    }

    onClickLogout = event => {
        event.preventDefault();
        this.props.onClickLogout();
    }

    onClickBack = event => {
        event.preventDefault();
        this.props.backToProfile();
    }

    onClickQRCode = event => {
        event.preventDefault();
        this.props.getAccessCode().then(() => {
            this.setState({ qrDialogOpen: true });
        })
    }

    closeQRCodeModal() {
      if (this.state.qrDialogOpen) {
        this.setState({ qrDialogOpen: false });
        window.currentModal.close();
        document.body.style.overflowY = 'scroll';
      }
    }

    downloadQR() {
        html2canvas(document.getElementById('#qrContainer')).then(function (canvas) {
            var url = canvas.toDataURL('image/png');
            var link = document.createElement('a');
            link.download = 'qr_code.png';
            link.href = url;
            link.click();
        });
    }

    selectLocale(locale) {
        const {
          selectLocale,
          loggedIn
        } = this.props;

        // select client side in redux
        selectLocale(locale);

        // save to server
        new UserService().setLocale(locale);
    }

    renderProfile() {
        let enableTerms = false;
        let hpxMacaoId = 4596;
        for (let storyId in this.props.accountSettings) {
          if (this.props.accountSettings[storyId].account_id === hpxMacaoId) {
            enableTerms = true;
            break
          }
        }

        let flags = LOCALES.map(locale => (
            <Menu.Item as='a' onClick={() => this.selectLocale(locale.locale)}>
              <Flag name={locale.flag} />
            </Menu.Item>
        ));

        let flagOptions = (
            <Menu className={this.props.classes.flagOptions} secondary>
                {flags}
            </Menu>
        );

        return (
            <Box sx={{ width: '100%' }}>
                <Stack spacing={2}
                    justifyContent="flext-start"
                    alignItems="flext-start">
                    {
                        this.props.showInfo &&
                        <Item>
                            <Stack
                                direction="row"
                                justifyContent="flext-start"
                                alignItems="center"
                                spacing={2}
                            >
                                <div>
                                    <img src='https://picsum.photos/id/237/200/300' size='tiny' verticalAlign='middle' width={80} height={80} />
                                </div>
                                <div>
                                    <h2>{this.props.userName}</h2>
                                </div>
                            </Stack>
                        </Item>
                    }
                    <Menu vertical fluid>
                        <Menu.Item onClick={this.onClickContactUs}>
                            <FormattedMessage {...messages.consumer_contact_us} />
                        </Menu.Item>
                        <Menu.Item onClick={this.onClickDeleteAcc}>
                            <FormattedMessage {...messages.consumer_my_personal_data} />
                        </Menu.Item>
                        {
                            enableTerms && 
                            <Menu.Item onClick={this.onClickTerms}>
                                <FormattedMessage {...messages.consumer_terms_of_use} />
                            </Menu.Item>
                        }
                        <Menu.Item onClick={this.onClickQRCode}>
                            <FormattedMessage {...messages.consumer_item_generate_qr_code} />
                        </Menu.Item>
                    </Menu>
                    <Button onClick={this.onClickLogout}>
                        <FormattedMessage {...messages.consumer_nav_logout} />
                    </Button>
                    {flagOptions}
                </Stack>
            </Box>
        )
    }

    renderQRCodeDialog(classes) {
        return (
            <QrCode qrDialogOpen={this.state.qrDialogOpen} closeQRCodeModal={this.closeQRCodeModal.bind(this)} />
        )
    }

    render() {
        const { classes } = this.props;
        switch (this.props.profile.state) {
            case SHOW_DELETE_MY_ACCOUNT:
            case SHOW_CONTACT_US:
                profileComponent =
                    <div>
                        <Button onClick={this.onClickBack}><FormattedMessage {...messages.button_back} /></Button>
                        <br />
                        <br />
                        <Embed active style={{ height: '1000px' }}>
                            <iframe src={this.props.profile.url} style={{ height: '100%' }} />
                        </Embed>
                    </div>

                break;
            case SHOW_TERMS_OF_USE:
                profileComponent =
                    <div>
                        <Button onClick={this.onClickBack}><FormattedMessage {...messages.button_back} /></Button>
                        <br />
                        <br />
                        <p style={{textAlign: "left", color: 'white'}}>
                            <FormattedMessage {...messages.hpx_macao_disclaimer} values={{ br: <br/> }} />
                        </p>
                    </div>

                break;
            default:
                profileComponent = this.renderProfile();
                break;
        }
        return (
            <>
                {profileComponent}
                {this.renderQRCodeDialog(classes)}
            </>
        )
    }
}

const mapStateToProps = state => ({
    profile: state.profilePageReducer.profile,
    access_code: state.userReducer.access_code,
    accountSettings: state.storyReducer.accountSettings,
});

const ProfilePageComponent = withStyles(styles, { withTheme: true })(ProfilePage);
export default connect(mapStateToProps, { getAccessCode, backToProfile, showDeleteMyAcc, showTerms, showContactUs, selectLocale })(ProfilePageComponent);
